import { type SxProps, type Theme } from "@mui/material";
import { mergeSxProps } from "@src/appV2/lib";
import { Avatar } from "@src/appV2/redesign/components/Avatar";
import { type TimeSlotWithExtras } from "@src/appV2/Shifts/types";

import { Text } from "../components/Text";

export interface TimeSlotAvatarProps {
  timeSlot: TimeSlotWithExtras;
  sx?: SxProps<Theme>;
}

/**
 * TimeSlotAvatar component displays a circular badge with AM/PM/NOC/ORI label
 * Uses theme background colors keyed by the time slot.
 */
export function TimeSlotAvatar(props: TimeSlotAvatarProps) {
  const { timeSlot, sx } = props;

  function getBackgroundColor(theme: Theme): string | undefined {
    return theme.palette[timeSlot]?.main;
  }

  return (
    <Avatar
      size="medium"
      sx={mergeSxProps(
        (theme: Theme) => ({
          backgroundColor: getBackgroundColor(theme),
          flexShrink: 0,
        }),
        sx
      )}
    >
      <Text>{timeSlot.toUpperCase()}</Text>
    </Avatar>
  );
}
